// Tremor Raw cx [v0.0.0]

import { User } from '@prisma/client'
import clsx, { type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cx(...args: ClassValue[]) {
  return twMerge(clsx(...args))
}

// Tremor Raw focusInput [v0.0.1]

export const focusInputClasses = [
  'border border-indigo-500 dark:border-indigo-500', // base
  'ring-2',
  // ring color
  'ring-indigo-200 dark:ring-indigo-700/30',
  // border color
  'border-indigo-500 dark:border-indigo-700',
]

export const focusInput = [
  // base
  'focus:ring-2',
  // ring color
  'focus:ring-indigo-200 focus:dark:ring-indigo-700/30',
  // border color
  'focus:border-indigo-500 focus:dark:border-indigo-700',
]

// Tremor Raw focusRing [v0.0.1]

export const focusRing = [
  // base
  'outline outline-offset-2 outline-0 focus-visible:outline-2',
  // outline color
  'outline-indigo-500 dark:outline-indigo-500',
]

// Tremor Raw hasErrorInput [v0.0.1]

export const hasErrorInput = [
  // base
  'ring-2',
  // border color
  'border-red-500 dark:border-red-700',
  // ring color
  'ring-red-200 dark:ring-red-700/30',
]

// Number formatter function

export const usNumberformatter = (number: number, decimals = 0) =>
  Intl.NumberFormat('us', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
    .format(Number(number))
    .toString()

export const percentageFormatter = (number: number, decimals = 1) => {
  const formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(number)
  const symbol = number > 0 && number !== Infinity ? '+' : ''

  return `${symbol}${formattedNumber}`
}

export const millionFormatter = (number: number, decimals = 1) => {
  const formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(number)
  return `${formattedNumber}M`
}
export const formatters: Record<string, any> = {
  currency: (number: number, currency = 'USD') =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    }).format(number),
  unit: (number: number) => `${usNumberformatter(number)}`,
}

export function getUserInitials(
  user: Pick<User, 'name' | 'email' | 'firstName' | 'lastName'>,
) {
  const { firstName, lastName } = user
  if (firstName && lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
  }
  return user.name ? getNameInitials(user.name) : getNameInitials(user.email)
}

export function getNameInitials(name: string) {
  if (/@/.test(name)) {
    name = name.split('@')[0]
  }
  if (!name) return ''
  const initials = name
    .split(/[\s.-]+/)
    .map((word) => word.charAt(0))
    .join('')
  return initials.length > 2
    ? initials.substring(0, 2).toUpperCase()
    : initials.toUpperCase()
}
